import RequestStatus from "../model/RequestStatus";
import {GetCurrentCountryCodeResponse, GetProductDataResponse} from "../model/ProductMatch";
import {
    CURRENT_COUNTRY_CODE_QUERY_FAILED,
    CURRENT_COUNTRY_CODE_QUERY_START, CURRENT_COUNTRY_CODE_QUERY_SUCCESS, CURRENT_COUNTRY_CODE_SET,
    GetCurrentCountryCodeComplete
} from "src/actions/CurrentCountryCodeQueryAction";
import {getCountryListConfig} from "src/config/Config";

const initialState: GetCurrentCountryCodeResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    currentCountryCode: null,
};

export default (
    state: GetCurrentCountryCodeResponse = initialState,
    action: GetCurrentCountryCodeComplete
): GetCurrentCountryCodeResponse => {
    switch (action.type) {
        case CURRENT_COUNTRY_CODE_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                currentCountryCode: null,
            };
        case CURRENT_COUNTRY_CODE_QUERY_SUCCESS:
        case CURRENT_COUNTRY_CODE_SET:
            return {
                requestStatus: RequestStatus.SUCCESS,
                currentCountryCode: action.currentCountryCode,
            };
        case CURRENT_COUNTRY_CODE_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                currentCountryCode: getCountryListConfig()[0],
            };
        default:
            return state;
    }
};

